import { Obj, configureContentBrowser } from "scrivito"

interface FilterOption {
  field?: string
  icon: string
  title: string
  value?: string
}

const FILTER_PRESENTATIONS: Record<string, FilterOption> = {
  PimData: { title: "Imports from PIM", icon: "pdf" },
  Download: { title: "Downloads", icon: "pdf" },
  Homepage: { title: "Homepage", icon: "inbox" },
  Image: { title: "Images", icon: "image" },
  Page: { title: "Standard pages", icon: "sheet" },
  Redirect: { title: "Redirects", icon: "link" },
  SearchResults: { title: "Search results", icon: "lens" },
  ProjectsPage: { title: "ProjectsPage", icon: "sheet" },
  LandingPage: { title: "LandingPage", icon: "sheet" },
  PortfolioPage: { title: "PortfolioPage", icon: "sheet" },
  KpiPage: { title: "KpiPage", icon: "sheet" },
  ProductCategory: { title: "ProductCategory", icon: "sheet" },
  ProductGroup: { title: "ProductGroup", icon: "sheet" },
  Product: { title: "Product", icon: "sheet" },
  ProductBaseVariant: {
    title: "ProductBaseVariant",
    icon: "sheet"
  },
  ContactDetails: { title: "ContactDetails", icon: "sheet" },
  Footer: { title: "Footer", icon: "sheet" },
  AppSidebar: { title: "App Sidebar", icon: "sheet" },
  BuildingReference: { title: "BuildingReference", icon: "sheet" },
  BuildingReferencesOverview: {
    title: "BuildingReferencesOverview",
    icon: "sheet"
  },
  InstallationReference: { title: "InstallationReference", icon: "sheet" },
  Tag: { title: "Tag", icon: "sheet" },
  PortalNewsPost: { title: "PortalNewsPost", icon: "sheet" },
  PortalNewsPage: { title: "PortalNewsPage", icon: "sheet" },
  FavoritesPage: { title: "FavoritesPage", icon: "sheet" },
  DimConfigurationAdminPage: { title: "DIM Admin Page", icon: "sheet" },
  FollowUpConfigurationAdminPage: {
    title: "Folgeprodukt-Verwaltung",
    icon: "sheet"
  },
  ProjectTeamInvitationListPage: {
    title: "Projekt Team Einladungen",
    icon: "sheet"
  }
}

const PAGES = [
  "Page",
  "Redirect",
  "Homepage",
  "SearchResults",
  "ProjectsPage",
  "LandingPage",
  "PortfolioPage",
  "KpiPage",
  "BuildingReferencesOverviewPage",
  "ProductCategory",
  "ProductGroup",
  "Product",
  "PimData",
  "PortalNewsPost",
  "PortalNewsPage",
  "DimConfigurationAdminPage",
  "FollowUpConfigurationAdminPage"
]

export function configureScrivitoContentBrowser() {
  configureContentBrowser({
    filters: ({ _validObjClasses }) => {
      if (_validObjClasses?.[1]) return filtersForObjClasses(_validObjClasses)
      if (_validObjClasses?.[0]) return filterForObjClass(_validObjClasses[0])
      return defaultFilters()
    }
  })
}

function filterForObjClass(objClass: string) {
  return {
    _objClass: {
      options: {
        [objClass]: {
          ...filterOptionForObjClass(objClass),
          selected: true
        }
      }
    }
  }
}

function filtersForObjClasses(objClasses: string[]) {
  return {
    _objClass: {
      options: {
        All: {
          title: "All",
          icon: "folder",
          field: "_objClass",
          value: objClasses,
          selected: true
        },
        ...objClasses.reduce((result, value) => {
          // eslint-disable-next-line no-param-reassign
          result[value] = filterOptionForObjClass(value)
          return result
        }, {} as Record<string, FilterOption>)
      }
    }
  }
}

function defaultFilters() {
  return {
    _objClass: {
      options: {
        All: {
          title: "All",
          icon: "folder",
          query: Obj.all(),
          selected: true
        },
        Image: filterOptionForObjClass("Image"),
        Pages: {
          title: "Pages",
          icon: "sheet",
          field: "_objClass",
          value: PAGES,
          options: PAGES.reduce((result, value) => {
            // eslint-disable-next-line no-param-reassign
            result[value] = filterOptionForObjClass(value)
            return result
          }, {} as Record<string, FilterOption>)
        },
        Download: filterOptionForObjClass("Download"),
        Video: filterOptionForObjClass("Video")
      }
    },
    _modification: {
      title: "Changed",
      type: "checkbox" as const,
      expanded: true,
      field: "_modification",
      options: {
        New: {
          value: "new"
        },
        Edited: {
          value: "edited"
        }
      }
    }
  }
}

function filterOptionForObjClass(
  objClass: keyof typeof FILTER_PRESENTATIONS | string
): FilterOption {
  const filterPresentation = isFilterPresentationsKey(objClass)
    ? FILTER_PRESENTATIONS[objClass]
    : {
        title: objClass,
        icon: "question"
      }

  return { field: "_objClass", value: objClass, ...filterPresentation }
}

function isFilterPresentationsKey(
  objClass: string
): objClass is keyof typeof FILTER_PRESENTATIONS {
  return Object.keys(FILTER_PRESENTATIONS).includes(objClass)
}
